import { render, staticRenderFns } from "./DadosVidaResumo.vue?vue&type=template&id=87049822&scoped=true&"
import script from "./DadosVidaResumo.vue?vue&type=script&lang=js&"
export * from "./DadosVidaResumo.vue?vue&type=script&lang=js&"
import style0 from "./DadosVidaResumo.vue?vue&type=style&index=0&id=87049822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87049822",
  null
  
)

export default component.exports